export const XS_BP = "576px";
export const SM_BP = "768px";
export const XL_BP = "1400px";
